/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const AngleLeftLightIcon = ({
  className,
  style: propStyles,
  color = '#3A50F3',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    ...propStyles,
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M5.46819 9.97715L12.7337 2.84183C13.0236 2.55272 13.4923 2.55272 13.7822 2.84183L14.2201 3.27856C14.51 3.56766 14.51 4.03515 14.2201 4.32425L7.91058 10.5L14.2139 16.6757C14.5038 16.9648 14.5038 17.4323 14.2139 17.7214L13.776 18.1582C13.4861 18.4473 13.0174 18.4473 12.7275 18.1582L5.46202 11.0228C5.17831 10.7337 5.17831 10.2663 5.46819 9.97715Z"
        fill={color}
      />
    </svg>
  );
};
